module.exports = "<div class=\"clearfix\">\r\n  <nuc-site-header></nuc-site-header>\r\n  <div class=\"contents hideOver\">\r\n    <router-outlet  (activate)=\"onActivate($event, outlet)\" #outlet></router-outlet>\r\n  </div>\r\n</div>\r\n<nuc-site-footer></nuc-site-footer>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/site/site.component.html
// module id = 1460
// module chunks = 3